<template>
  <div
    class="mobile-menu top-0 position-fixed d-flex justify-content-center align-items-center"
    :class="{ 'opening-transition': burgerMenuOpen }"
  >
    <!-- Links List  -->
    <nav class="mobile-nav">
      <ul class="links-list">
        <li class="link" v-for="(link, i) in links" :key="i">
          <div @click="$emit('linkClicked'), scrollView(link.pushTo)">
            {{ link.name }}
          </div>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "MobileMenu",
  props: {
    burgerMenuOpen: Boolean,
  },
  data: function () {
    return {
      links: [
        {
          name: "Chi Siamo",
          pushTo: "about",
        },
        {
          name: "Contatti",
          pushTo: "contact-us",
        },
        {
          name: "Servizi",
          pushTo: "services",
        },
      ],
    };
  },
  methods: {
    scrollView: function (pushTo) {
      document.getElementById(`${pushTo}`).scrollIntoView();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.mobile-menu {
  width: 100vw;
  height: 100vh;
  background-color: rgba($color: $back_dark_color, $alpha: 0.88);
  backdrop-filter: blur(0.20em);
  z-index: 2;
  left: 100%;
  transition: all 0.5s ease-in-out;

  &.opening-transition {
    left: 0;
  }

  .mobile-nav {
    width: 80%;
    
    .links-list {
      .link {
        color: $brand_primary_color;
        line-height: 1.75em;
        text-transform: uppercase;
        font-size: 2.5rem;
        border-bottom: 2px solid $brand_primary_color;
        text-align: center;
      }
    }
  }
}
</style>
